class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/segments'
			},
			delete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/segment/delete'
			},
			search: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/segment/search'
			},
			update: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/segment/update'
			},
			insert: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/segment/insert'
			},
			fetchCustomerSegment: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/customer/segment'
			},
			customerLastSegment: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/customer/last/segment'
			},
			addCustomerSegment: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/customer/segment'
			}
		};
	}
}

export default new APIS();
